<template>
	<div class="no-results basic-formatting">
		<template v-if="hasMiniferieDuration">
			<p>{{translations.search.noResult.intro}}</p>
			<p>{{translations.search.noResult.hasMiniferie}}</p>
			<Spinner v-if="isFetching" />
			<template v-else-if="lodgings.length > 0">
				<FeriehusItem v-for="(lodging, index) in lodgings" :key="lodging.position" :lodging="lodging" />
			</template>
		</template>
		<template v-else>
			<p>{{translations.search.noResult.intro}}</p>
			<search-tags-display/>
			<p><strong>{{translations.search.noResult.listStart}}</strong></p>
			<ul>
				<li>{{translations.search.noResult.tip1}}</li>
				<li>{{translations.search.noResult.tip2}}</li>
				<li @click="handleClickable($event, 'freetext')" v-html="translations.search.noResult.tip3" />
				<li @click="handleClickable($event,'all')" v-html="translations.search.noResult.tip4" />
			</ul>

			<p><strong>{{translations.search.noResult.outro1}}</strong></p>
			<p>{{translations.search.noResult.outro2}}</p>
		</template>
	</div>
</template>

<script>
	import { resetAllSearchParts } from '@js/parts/search/functions/reset/resetAllSearchParts'
	import {refreshSearch} from "@js/parts/search/functions/refreshSearch";
	import SearchTagsDisplay from "@vue/components/search/SearchTagsDisplay.vue";
	import {mapState} from 'vuex';
	import axios from "axios";
	import buildSearchRequestUrl from "@js/parts/search/functions/buildSearchRequestUrl";
	import Spinner from "@vue/components/loaders/Spinner";
	import FeriehusItem from "@vue/components/search/FeriehusItem";
	export default {
		components:{
			FeriehusItem,
			Spinner,
			SearchTagsDisplay
		},
		data(){
			return {
				isFetching: true,
				lodgings: []
			}
		},
		computed: {
			...mapState({
				translations: 'translations',
				search: 'search'
			}),
			hasMiniferieDuration(){
				return typeof this.search.parameters.duration !== 'undefined' && ['3','4','5','6'].indexOf(this.search.parameters.duration) !== -1
			}
		},
		methods: {
			handleClickable(event,type){
				if(typeof event.target !== 'undefined' && event.target.classList.contains('clickable'))
				{
					if(type === 'freetext')
					{
						$('#freetext').val('').trigger('input');
					}
					else if(type === 'all')
					{
						resetAllSearchParts(false);
						refreshSearch();
					}
				}
			},
			fetchNoDurationSearch(){
				let parameters = Object.assign({},this.search.queryParameters);
				delete parameters.duration;
				this.isFetching = true;
				axios({ method: 'GET', url: buildSearchRequestUrl(parameters), headers: {'Content-Type': 'application/json'}})
				.then(response => {
					if(typeof response.data.result !== 'undefined')
						this.lodgings = response.data.result
					this.isFetching = false;
				})
				.catch(() => {
					this.isFetching = false;
				});
			}
		},
		mounted() {
			if(this.hasMiniferieDuration)
				this.fetchNoDurationSearch();
		}
	};
</script>

<style scoped>

</style>
